<template>
  <div>
    <Header></Header>
    <router-view />
  </div>
</template>

<script>
import "@/assets/styles/auth/main.scss";

import Header from "@/components/auth/Header";

// Возврат со Stripe (/success, /error) — в стиле остальных страниц из писем,
// адаптивно: responsive снимает десктопную ширину body.
export default {
  name: "Payment",
  components: {
    Header,
  },
  mounted() {
    document.body.classList.add("responsive", "intropage");
  },
  beforeDestroy() {
    document.body.classList.remove("responsive", "intropage");
  },
};
</script>
